import React from "react";
import { Redirect } from "react-router-dom";
import i18next from "i18next";

import fr_CA from "./i18n/fr_CA";
import en_CA from "./i18n/en_CA";

i18next.addResourceBundle("fr-CA", "itemsApp", fr_CA);
i18next.addResourceBundle("en-CA", "itemsApp", en_CA);

export const ItemsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  name: "Items",
  auth: "item_management",
  routes: [
    {
      path: "/app/items/item/:itemId/:itemSlug?",
      component: React.lazy(() => import("./views/Item")),
    },
    {
      path: "/app/items/list",
      component: React.lazy(() => import("./views/List")),
    },
    {
      path: "/app/items",
      component: () => <Redirect to="/app/items/list" />,
    },
  ],
};
